import angular from 'angular';
import './grid.component.js';

class LadproviderList {
  /*@ngInject*/
  constructor(logger, LadProviderService) {
    this.logger = logger;
    this.LadProviderService = LadProviderService;
    this.gridParams = {};
    this.gridParams.paginationPageSizes = [20, 50, 100];
    this.gridParams.paginationPageSize = 20;
    this.data = {};
  }

  $onInit() {
    let vm = this;
    vm.data = vm.ladproviders;
    vm.gridSize = vm.ladproviders.length;
  }
}

angular.module('app.ladprovider').component('ladproviderList', {
  templateUrl: require('./ladprovider-list.html'),
  controller: LadproviderList,
  bindings: {
    ladproviders: '<'
  }
});
